<template>
  <div class="sm-notification-top terms">
    <div class="sm-wrap">
      <div 
        class="sm-notification-top__terms"
        @click="highlightNotif"
      >
        <include-svg :name="'icon-documents-approve'" />
        <span>Uploaded documents awaiting your approval</span>
        <a
          href="#"
          class="sm-notification-top__terms-close"
          @click.stop="$emit('close')"
        >
          <include-svg :name="'icon-action-close'" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'approve-notification',
  computed: {
    ...mapGetters({
      customersList: 'customers/customersList'
    })
  },
  methods: {
    highlightNotif() {
      let elems = Array.from(document.querySelectorAll('.to-approve'));

      if (!elems.length)
        return;

      elems[0].scrollIntoView({
        block: 'center',
        behavior: 'smooth'
      });

      elems.forEach(elem => {
        setTimeout(() => {
          elem.classList.add('highlight');

          setTimeout(() => {
            elem.classList.remove('highlight');
          }, 300);
        }, 300);
      });
    }
  }
}
</script>